// extracted by mini-css-extract-plugin
export default {"root":"TjPyPZwB","title":"YcZ93afk","subtitle":"f1oDCaIQ","line":"XMmJlPyG","cancelIcon":"W2c0fwcW","image":"gjKttZto"};